// Types
import { RootState } from 'types/RootState.types';

export const getGiftCardApplyGiftPaymentFailedSelector =
    (state: RootState) => state.giftCard?.applyGiftPaymentFailed ?? false;
export const getGiftCardErrorMessageSelector = (state: RootState) => state.giftCard?.errorMessage;
export const getGiftCardFormSubmitFailedSelector = (state: RootState) => state.giftCard?.formSubmitFailed ?? false;
export const getGiftCardIsLoadingSelector = (state: RootState) => state.giftCard?.isLoading ?? false;
